import '../scss/theme.scss';
import * as bootstrap from 'bootstrap';
import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

import smoothscroll from 'smoothscroll-polyfill';
import smoothscrollAnchorPolyfill from 'smoothscroll-anchor-polyfill';
smoothscroll.polyfill();

/*
 * Application
 */
$(function() {

    /*
     * Auto hide navbar on scroll down, show on scroll up
     */
    var $header = $('.navbar-autohide'),
        scrolling = false,
        previousTop = 0,
        scrollDelta = 10,
        scrollOffset = 150;

    $(window).on('scroll', function(){
        if (!scrolling) {
            scrolling = true;

            if (!window.requestAnimationFrame) {
                setTimeout(autoHideHeader, 250);
            }
            else {
                requestAnimationFrame(autoHideHeader);
            }
        }
    });

    function autoHideHeader() {
        var currentTop = $(window).scrollTop();

        if (previousTop - currentTop > scrollDelta) {
            $header.removeClass('is-hidden');
        }
        else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
            $header.addClass('is-hidden');
        }

        previousTop = currentTop;
        scrolling = false;
    }

    /*
     * Navbar background: add solid bg after scrolling past hero
     */
    function updateNavBg() {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > 20) {
            $header.addClass('navbar--scrolled');
        } else {
            $header.removeClass('navbar--scrolled');
        }
    }

    $(window).on('scroll', updateNavBg);
    updateNavBg();

    /*
     * Properties carousel — Splide.js, 3 cards per page, autoplay every 3 s
     */
    var propertiesEl = document.getElementById('propertiesCarousel');
    if (propertiesEl) {
        new Splide(propertiesEl, {
            type       : 'loop',
            perPage    : 3,
            perMove    : 3,
            gap        : '32px',
            autoplay   : true,
            interval   : 3000,
            speed      : 500,
            pauseOnHover: true,
            arrows     : false,
            pagination : true,
            breakpoints: {
                991: {
                    perPage: 2,
                    perMove: 2,
                    gap    : '24px',
                },
                575: {
                    perPage: 1,
                    perMove: 1,
                    gap    : '16px',
                },
            },
        }).mount();
    }

    /*
     * PhotoSwipe lightbox — article galleries
     */
    if (document.querySelector('.aktualita-gallery-grid')) {
        const lightbox = new PhotoSwipeLightbox({
            gallery: '.aktualita-gallery-grid',
            children: 'a.aktualita-gallery-item',
            pswpModule: () => import('photoswipe'),
        });
        lightbox.init();
    }

    /*
     * Demonstration-apartment gallery — show a "+N" overlay on the last visible
     * thumbnail (one row only: desktop 6 / tablet 4 / mobile 2)
     */
    var byvanieGrid = document.querySelector('.byvanie-gallery-grid');
    if (byvanieGrid) {
        var byvanieItems = Array.prototype.slice.call(byvanieGrid.querySelectorAll('.byvanie-gallery-item'));
        var byvanieTotal = byvanieItems.length;

        var byvanieColumns = function() {
            var w = window.innerWidth;
            if (w <= 575.98) return 2;
            if (w <= 991.98) return 3;
            return 4;
        };

        var updateByvanieOverlay = function() {
            var cols = byvanieColumns();
            byvanieItems.forEach(function(item) {
                item.classList.remove('is-last-visible');
            });
            if (byvanieTotal > cols) {
                var last = byvanieItems[cols - 1];
                if (last) {
                    last.classList.add('is-last-visible');
                    var countEl = last.querySelector('.byvanie-gallery-more-count');
                    if (countEl) countEl.textContent = '+' + (byvanieTotal - cols);
                }
            }
        };

        updateByvanieOverlay();
        window.addEventListener('resize', updateByvanieOverlay);
    }

    /*
     * Table scroll hints — show left/right chevrons when table overflows horizontally
     */
    var tableWrap = document.querySelector('.zverej-table-wrap');
    if (tableWrap) {
        var hintLeft  = document.querySelector('.zverej-scroll-hint--left');
        var hintRight = document.querySelector('.zverej-scroll-hint--right');

        function updateScrollHints() {
            var hasOverflow = tableWrap.scrollWidth > tableWrap.clientWidth;
            var scrollLeft  = tableWrap.scrollLeft;
            var maxScroll   = tableWrap.scrollWidth - tableWrap.clientWidth;

            hintLeft.classList.toggle('is-visible',  hasOverflow && scrollLeft > 1);
            hintRight.classList.toggle('is-visible', hasOverflow && scrollLeft < maxScroll - 1);
        }

        tableWrap.addEventListener('scroll', updateScrollHints, { passive: true });
        window.addEventListener('resize', updateScrollHints);
        updateScrollHints();
    }

    /*
     * Smooth scroll for [data-scroll] anchor links
     */
    $('[data-scroll]').on('click', function(e) {
        var href = $(this).attr('href');
        if (href && href.charAt(0) === '#') {
            var $target = $(href);
            if ($target.length) {
                e.preventDefault();
                var navHeight = $('#layout-nav').outerHeight() || 70;
                $('html, body').animate({
                    scrollTop: $target.offset().top - navHeight - 16
                }, 500);
            }
        }
    });

});
